module.exports = __webpack_public_path__ + "img/18.982aaa96.png";